<template>
  <div class="text-sm mb-8 template-content" v-html="template"></div>
</template>

<script>
import DOMPurify from "./dom-sanitiser";

export default {
  name: "TemplateField",
  props: ["field"],
  computed: {
    template() {
      if (!this.field.templateOptions.description) {
        return "";
      }
      return DOMPurify.sanitize(this.field.templateOptions.description, {
        ALLOWED_TAGS: ["b", "a", "hr", "h2", "br", "p"]
      });
    }
  }
};
</script>

<style>
  .template-content > a {
    @apply text-blue-700;
  }
  .template-content > a:hover {
    @apply underline;
  }
  .template-content hr {
    @apply my-8;
  }
  .template-content h2 {
    @apply text-xl mb-4;
  }
  .template-content p {
    @apply mb-2;
  }
</style>
